import { render, staticRenderFns } from "./FollowerContent.vue?vue&type=template&id=1258badf&scoped=true&"
import script from "./FollowerContent.vue?vue&type=script&lang=js&"
export * from "./FollowerContent.vue?vue&type=script&lang=js&"
import style0 from "./FollowerContent.vue?vue&type=style&index=0&id=1258badf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1258badf",
  null
  
)

export default component.exports